module.exports = __webpack_public_path__ + "assets/AV_CodeFish_v1_0.pdf";